module.exports = "mutation DeleteNote($id: ID!) {\n  deleteNote(id: $id) {\n    deleted\n  }\n}\n"